import React from 'react';
import { ISvgIconProps, } from './interface';
import { SvgIcon, } from './SvgIcon';

export const PlayIcon = (props: ISvgIconProps) => {
  return <SvgIcon {...props}>
    <polygon points="7 3 21 12 7 21 7 3"></polygon>
  </SvgIcon>;
};
